import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelProcessShipment} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class StartShipmentFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId
    }
    return this.props.startShipment(updatedValues)
      .then((response) => {
        if (response.data.startShipment.errors.length <= 0) {
          this.props.cancelProcessShipment();
        } else {
          let errors = createValidationErrors(response.data.startShipment.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelProcessShipment();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Start shipment for this order?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const START_SHIPMENT = gql`
  mutation startShipment($data: ShippingIdInput!) {
    startShipment(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(START_SHIPMENT, {
    props: ({ mutate }) => ({
      startShipment: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelProcessShipment})(withMutation(StartShipmentFormContainer));